<template>
  <v-container fluid>
    <v-card v-if="isWordListReady && !displayConfirmDialog && !displayCompletedDialog" flat>
      <v-card-title class="mb-3 text-h5 font-weight-bold">
        {{ wordList.lbl_stock_collect_regist }}
      </v-card-title>
      <Form v-slot="{ meta }" ref="formRef">
        <v-card-text>
          <v-card flat class="pt-3">
            <v-card-text class="px-0">
              <!-- 区分 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_delivery_kbn }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6">
                  <v-radio-group
                    v-model="deliveryKbnSelectValues"
                    inline
                    mandatory
                    class="mt-0"
                  >
                    <v-radio
                      v-for="item in deliveryKbnRadioItems"
                      :key="item.index"
                      :label="item.item"
                      :value="item"
                      color="indigo"
                      density="compact"
                      @click="onClickDeliveryKbn"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>
              <!-- 配達元 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_delivery_source }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col
                  cols="11"
                  sm="6"
                  md="6"
                  lg="6"
                  class="font-weight-black position-re"
                >
                  <v-card class="bk_gray_3" flat border>
                    <v-card-text>
                      <v-row dense>
                        <v-col class="font-weight-black">
                          <Field
                            v-slot="{ field, errors }"
                            :name="wordList.lbl_delivery_source"
                            :model-value="shopSelectValues_from"
                          >
                            <v-autocomplete
                              :model-value="shopSelectValues_from?.shop_code ? shopSelectValues_from : null"
                              density="compact"
                              bg-color="#fff"
                              :items="shopFromListItems"
                              item-title="name"
                              item-value="shop_code"
                              :placeholder="wordList.plc_selectbox"
                              persistent-placeholder
                              :error-messages="errors"
                              :no-data-text="wordList.lbl_no_data_text"
                              return-object
                              variant="outlined"
                              @update:model-value="onUpdateShopFrom"
                              @blur="field.onBlur"
                            ></v-autocomplete>
                          </Field>
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col class="color_black">
                          {{ shopData_from_address }}
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <!-- 配達先 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_delivery_destination }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="11" sm="6" md="6" lg="6" class="font-weight-black">
                  <v-card class="bk_gray_3" flat border>
                    <v-card-text>
                      <v-row v-if="shopSelectValues_from && shopSelectValues_from.shop_code" dense>
                        <v-col class="font-weight-black">
                          <Field
                            v-slot="{ field, errors }"
                            :name="wordList.lbl_delivery_destination"
                            :model-value="shopSelectValues_to"
                          >
                            <v-autocomplete
                              :model-value="shopSelectValues_to?.shop_code ? shopSelectValues_to : null"
                              density="compact"
                              bg-color="#fff"
                              :items="shopToListItems"
                              item-title="name"
                              item-value="shop_code"
                              :placeholder="wordList.plc_selectbox"
                              persistent-placeholder
                              :error-messages="errors"
                              :no-data-text="wordList.lbl_no_data_text"
                              return-object
                              variant="outlined"
                              @update:model-value="onUpdateShopTo"
                              @blur="field.onBlur"
                            ></v-autocomplete>
                          </Field>
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col class="color_red">
                          ※配達元から配達可能な店舗のみが表示されます。
                        </v-col>
                      </v-row>
                      <v-row dense>
                        <v-col class="color_black">
                          {{ shopData_to_address }}
                        </v-col>
                      </v-row>
                    </v-card-text>
                  </v-card>
                </v-col>
              </v-row>
              <!-- エリア -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_area }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                  md="6"
                  lg="6"
                  class="text-body-1 color_black"
                >
                  <v-row
                    v-show="
                      listDeliveryArea == null || listDeliveryArea.length <= 1
                    "
                    dense
                  >
                    <Field :name="wordList.lbl_area" rules="required">
                      <v-text-field
                        v-model="deliveryAreaName"
                        class="border-none disabled-text-field"
                        density="compact"
                        variant="plain"
                        disabled
                      >
                      </v-text-field>
                    </Field>
                  </v-row>
                  <v-row
                    v-show="
                      listDeliveryArea !== null && listDeliveryArea.length > 1
                    "
                    dense
                  >
                    <v-btn
                      v-for="value in listDeliveryArea"
                      :key="value.area_code"
                      class="my-2 mx-2"
                      :class="{
                        btn_select_del_active:
                          value.area_code ===
                          transPickupRequestCreateInput.area_code,
                      }"
                      color="primary"
                      variant="outlined"
                      min-width="200"
                      @click="onClickListDeliveryArea(value)"
                    >
                      {{ value.area_name }}
                    </v-btn>
                  </v-row>
                </v-col>
              </v-row>
              <!-- 配達希望時間選択 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList.lbl_delivery_time_select }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col
                  cols="12"
                  sm="8"
                  md="8"
                  lg="8"
                  class="text-body-1 color_black"
                >
                  <Field
                    :name="wordList.lbl_delivery_time_select"
                    rules="required"
                  >
                    <v-text-field
                      v-model="display_delivery_time"
                      class="border-none disabled-text-field"
                      density="compact"
                      variant="plain"
                      disabled
                      hide-details
                    >
                    </v-text-field>
                  </Field>
                  <v-card
                    v-if="disp_deliveryAvailabilityData.length > 0"
                    class="mt-2 mb-8 px-3 py-3"
                    flat
                    border
                  >
                    <div id="wrap">
                      <div class="d-flex overflow-x-auto">
                        <div>
                          <div class="list_item_select_blank"></div>
                          <ul class="list_area br_b_1">
                            <li
                              v-for="[
                                delivery_id_desc,
                              ] in deliveryAvailabilityHeader"
                              :key="delivery_id_desc"
                              class="list_item_select_time"
                            >
                              {{ delivery_id_desc }}
                            </li>
                          </ul>
                        </div>
                        <div class="d-flex overflow-scrollr br_b_1">
                          <div
                            v-for="(
                              cols, deliverySelectDay
                            ) in disp_deliveryAvailabilityData"
                            :key="cols.delivery_data"
                          >
                            <ul
                              v-for="(delivery_data, deliverySelect) in cols"
                              :key="
                                delivery_data.delivery_date + delivery_data.key
                              "
                              class="list_area list_area_item"
                            >
                              <li
                                v-if="delivery_data.key == 1"
                                class="list_item_select list_item_day"
                              >
                                <div>
                                  <p class="mb-0">
                                    {{
                                      formatDate(delivery_data.delivery_date)
                                    }}
                                  </p>
                                </div>
                              </li>
                              <li class="list_item_select list_item_btn">
                                <a
                                  v-if="
                                    delivery_data.already_requested !== 1 &&
                                    delivery_data.availability !== '×' &&
                                    delivery_data.availability !== '0' &&
                                    delivery_data.availability !== '休'
                                  "
                                  class="btn_select_del"
                                  :class="{
                                    btn_select_del_active:
                                      deliverySelectDay ===
                                        deliverySelectDayBox &&
                                      deliverySelect === deliverySelectBox,
                                  }"
                                  @click="
                                    onDeliveryAvailabilityClick(
                                      delivery_data.delivery_date,
                                      delivery_data.delivery_id,
                                      delivery_data.delivery_start_time,
                                      delivery_data.delivery_end_time,
                                      deliverySelectDay,
                                      deliverySelect
                                    )
                                  "
                                >
                                  <!--<i :class="getClass(delivery_data.availability)"></i>-->
                                  <i
                                    v-if="delivery_data.availability == '○'"
                                    class="circle_receive"
                                    :class="{
                                      circle_receive_active:
                                        deliverySelectDay ===
                                          deliverySelectDayBox &&
                                        deliverySelect === deliverySelectBox,
                                    }"
                                  ></i>
                                  <i
                                    v-else-if="
                                      delivery_data.availability == '▲' ||
                                      delivery_data.availability == '△'
                                    "
                                    class="triangle_receive"
                                    :class="{
                                      triangle_receive_active:
                                        deliverySelectDay ===
                                          deliverySelectDayBox &&
                                        deliverySelect === deliverySelectBox,
                                    }"
                                  ></i>
                                  <i
                                    v-else-if="
                                      !isNaN(delivery_data.availability) &&
                                      delivery_data.availability > 0
                                    "
                                    class="text_16px font-weight-bold color_primary"
                                  >
                                    {{ delivery_data.availability }}
                                  </i>
                                </a>
                                <div
                                  v-if="
                                    delivery_data.availability === '×' ||
                                    delivery_data.availability === '0'
                                  "
                                  class="btn_select_del_dis"
                                >
                                  <i class="batsu_receive"></i>
                                </div>
                                <div
                                  v-else-if="
                                    delivery_data.availability === '休'
                                  "
                                  class="text_16px font-weight-bold color_primary"
                                >
                                  {{ delivery_data.availability }}
                                </div>
                                <!-- 済み(チェックボックス) -->
                                <!-- <div class="btn_select_del_dis">
                                  <v-icon>mdi-check-bold</v-icon>
                                </div> -->
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-card>
                  <p v-if="deliveryId_0_Flg" class="pt-0 mt-0">
                    ※配達開始時間
                    {{ deliveryStartTime }}～(当日配達)受付終了時間
                    {{ acceptableEndTime }}まで
                  </p>
                </v-col>
              </v-row>
              <!-- 配達希望時間 -->
              <v-row
                v-if="
                  deliveryId_0_Flg &&
                  transPickupRequestCreateInput.delivery_id !== undefined &&
                  transPickupRequestCreateInput.delivery_id != null
                "
                dense
              >
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
                    {{ wordList.lbl_delivery_time }}
                  </v-row>
                </v-col>
                <v-col cols="12" sm="8" md="8" lg="8">
                  <div class="d-flex align-center delivery-time-row">
                    <div class="delivery-time-select">
                      <v-autocomplete
                        v-model="deliveryStartHourValues"
                        density="compact"
                        :items="deliveryStartHourItem"
                        item-title="deliveryStartHour"
                        item-value="deliveryStartHour"
                        :no-data-text="wordList.lbl_no_data_text"
                        bg-color="white"
                        return-object
                        variant="outlined"
                        @update:model-value="onChangeDeliveryStartHour"
                      ></v-autocomplete>
                    </div>
                    <span class="mx-1 text-body-1 text-black">時</span>
                    <div class="delivery-time-select">
                      <v-autocomplete
                        v-model="deliveryStartMinitValues"
                        density="compact"
                        :items="deliveryStartMinitItem"
                        item-title="label"
                        item-value="deliveryStartMinit"
                        :no-data-text="wordList.lbl_no_data_text"
                        bg-color="white"
                        return-object
                        variant="outlined"
                        @update:model-value="onChangeDeliveryStartMinit"
                      ></v-autocomplete>
                    </div>
                    <span class="mx-1 text-body-1 text-black">分から3時間以内</span>
                  </div>
                </v-col>
              </v-row>
              <!-- 決済方法 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
                    {{ wordList.lbl_pay_method }}
                  </v-row>
                </v-col>
                <v-col cols="10" sm="4" md="4" lg="4">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_pay_method"
                    :model-value="transPickupRequestCreateInput.payment_method"
                  >
                    <v-autocomplete
                      v-model="transPickupRequestCreateInput.payment_method"
                      density="compact"
                      :items="paymentMethodItems"
                      :placeholder="wordList.plc_selectbox"
                      :no-data-text="wordList.lbl_no_data_text"
                      :error-messages="errors"
                      variant="outlined"
                      return-object
                      @update:model-value="
                        onChangePaymentMethod(
                          transPickupRequestCreateInput.payment_method
                        )
                      "
                      @blur="field.onBlur"
                    ></v-autocomplete>
                  </Field>
                </v-col>
              </v-row>
              <!-- 支払金額 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center"
                    v-if="paymentRequiredFlg"
                    dense
                      class="form-label-row mr-3 justify-sm-end"
                  >
                    {{ wordList.lbl_pay_money }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                  <v-row align="center"
                    v-if="!paymentRequiredFlg"
                    dense
                      class="form-label-row mr-15 justify-sm-end"
                  >
                    {{ wordList.lbl_pay_money }}
                  </v-row>
                </v-col>
                <v-col cols="8" sm="2" md="2" lg="2">
                  <Field
                    v-if="paymentRequiredFlg"
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_pay_money"
                    rules="required|max:11"
                    :model-value="dummy_payment_amount"
                  >
                    <v-text-field
                      v-model="dummy_payment_amount"
                      class="text-right"
                      :placeholder="wordList.plc_pay_money"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      @focus="onFocus(dummy_payment_amount)"
                      @blur="() => { onBlur(dummy_payment_amount); field.onBlur(); }"
                    >
                    </v-text-field>
                  </Field>
                  <Field
                    v-if="!paymentRequiredFlg"
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_pay_money"
                    rules="max:11"
                    :model-value="dummy_payment_amount"
                  >
                    <v-text-field
                      v-model="dummy_payment_amount"
                      class="text-right"
                      :placeholder="wordList.plc_pay_money"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      @focus="onFocus(dummy_payment_amount)"
                      @blur="() => { onBlur(dummy_payment_amount); field.onBlur(); }"
                    >
                    </v-text-field>
                  </Field>
                </v-col>
                <span class="mt-3">円</span>
              </v-row>
              <!-- レジNo -->
              <!--
              <v-row dense>
                <v-col
                  cols="12"
                  sm="4"
                  md="4"
                  lg="4"
                  class="font-weight-black"
                >
                  <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
                    {{ wordList.lbl_cash_register_no }}
                  </v-row>
                </v-col>
                <v-col cols="8" sm="2" md="2" lg="2">
                  <Field
                    v-slot="{ errors }"
                    :name="wordList.lbl_cash_register_no"
                    rules="numeric|max:4"
                  >
                    <v-text-field
                      dense
                      outlined
                      v-model="transPickupRequestCreateInput.register_no"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </Field>
                </v-col>
              </v-row>
-->
              <!-- レシートNo -->
              <!--
              <v-row dense>
                <v-col
                  cols="12"
                  sm="4"
                  md="4"
                  lg="4"
                  class="font-weight-black"
                >
                  <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
                    {{ wordList.lbl_receipt_no }}
                  </v-row>
                </v-col>
                <v-col cols="8" sm="2" md="2" lg="2">
                  <Field
                    v-slot="{ errors }"
                    :name="wordList.lbl_receipt_no"
                    rules="numeric|max:4"
                  >
                    <v-text-field
                      dense
                      outlined
                      v-model="transPickupRequestCreateInput.receipt_no"
                      :error-messages="errors"
                    >
                    </v-text-field>
                  </Field>
                </v-col>
              </v-row>
-->
              <!-- 個口数 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
                    {{ wordList["lbl_unit_number"] }}
                    <ImportantChip></ImportantChip>
                  </v-row>
                </v-col>
                <v-col cols="8" sm="2" md="2" lg="2">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_delivery_destination"
                    rules="required"
                    :model-value="transPickupRequestCreateInput.unit"
                  >
                    <v-autocomplete
                      v-model="transPickupRequestCreateInput.unit"
                      :items="unitItems"
                      :no-data-text="wordList.lbl_no_data_text"
                      :error-messages="errors"
                      density="compact"
                      variant="outlined"
                      return-object
                      @blur="field.onBlur"
                    ></v-autocomplete>
                  </Field>
                </v-col>
              </v-row>
              <!-- 備考 -->
              <v-row dense>
                <v-col cols="12" sm="4" md="4" lg="4" class="font-weight-black">
                  <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
                    {{ wordList.lbl_memo }}
                  </v-row>
                </v-col>
                <v-col cols="12" sm="6" md="6" lg="6">
                  <Field
                    v-slot="{ field, errors }"
                    :name="wordList.lbl_memo"
                    :model-value="transPickupRequestCreateInput.delivery_notes"
                  >
                    <v-textarea
                      v-model="transPickupRequestCreateInput.delivery_notes"
                      density="compact"
                      variant="outlined"
                      :error-messages="errors"
                      @blur="field.onBlur"
                    >
                    </v-textarea>
                  </Field>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="justify-center py-10">
              <v-btn
                variant="flat"
                color="primary"
                class="px-16"
                :disabled="!isFormValid"
                @click="onClickOpenConfirmDialog"
              >
                <v-icon>mdi-playlist-edit</v-icon>
                {{ wordList.btn_regist_confirm }}
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-card-text>
      </Form>
    </v-card>
    <!-- 配達依頼登録確認ダイアログ { -->
    <v-card v-if="displayConfirmDialog" flat>
      <v-card-title class="mb-3 text-h5 font-weight-bold">
        {{ wordList.lbl_delivery_move_regist_confirm }}
      </v-card-title>
      <v-card-text class="pt-5 confirm-display-text">
        <!-- ２件分配達となる場合のメッセージ -->
        <v-row v-if="isDoubleDeli" class="time_chk_card">
          <v-col cols="10" class="text-subtitle-1 text-red">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <span v-html="doubleDeliCheckLabel"></span>
          </v-col>
        </v-row>
        <!-- チャーター便となる場合のメッセージ -->
        <v-row v-if="isCharterDeli" class="time_chk_card">
          <v-col cols="10" class="text-subtitle-1 text-red">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <span v-html="charterDeliChkLabel"></span>
          </v-col>
        </v-row>
        <!-- 区分 -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="5" md="5" lg="5" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
              {{ wordList.lbl_delivery_kbn }}
              <ImportantChip></ImportantChip>
            </v-row>
          </v-col>
          <v-col cols="12" sm="7" md="7" lg="7">{{
            deliveryKbnSelectValues.item
          }}</v-col>
        </v-row>
        <!-- 配達元 -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="5" md="5" lg="5" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
              {{ wordList.lbl_delivery_source }}
              <ImportantChip></ImportantChip>
            </v-row>
          </v-col>
          <v-col cols="12" sm="7" md="7" lg="7">{{
            shopSelectValues_from.name
          }}</v-col>
        </v-row>
        <!-- 配達先 -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="5" md="5" lg="5" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
              {{ wordList.lbl_delivery_destination }}
              <ImportantChip></ImportantChip>
            </v-row>
          </v-col>
          <v-col cols="12" sm="7" md="7" lg="7">{{
            shopSelectValues_to.name
          }}</v-col>
        </v-row>
        <!-- エリア -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="5" md="5" lg="5" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
              {{ wordList.lbl_area }}
              <ImportantChip></ImportantChip>
            </v-row>
          </v-col>
          <v-col cols="12" sm="7" md="7" lg="7">
            {{ deliveryAreaName }}
          </v-col>
        </v-row>
        <!-- 配達希望時間選択 -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="5" md="5" lg="5" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
              {{ wordList.lbl_delivery_time_select }}
              <ImportantChip></ImportantChip>
            </v-row>
          </v-col>
          <v-col cols="12" sm="7" md="7" lg="7">
            {{ display_delivery_time }}
          </v-col>
        </v-row>
        <!-- 配達希望時間 -->
        <v-row v-if="deliveryId_0_Flg" dense class="mb-3">
          <v-col cols="12" sm="5" md="5" lg="5" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_delivery_time }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="7" md="7" lg="7">
            {{ irregularDeliveryStartTime }}&nbsp;～&nbsp;
            {{ irregularDeliveryEndTime }}
          </v-col>
        </v-row>
        <!-- 決済方法 -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="5" md="5" lg="5" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_pay_method }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="7" md="7" lg="7">{{
            transPickupRequestCreateInput.payment_method
          }}</v-col>
        </v-row>
        <!-- 支払金額 -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="5" md="5" lg="5" class="font-weight-black">
            <v-row align="center"
              v-if="paymentRequiredFlg"
              dense
                class="form-label-row mr-3 justify-sm-end"
            >
              {{ wordList.lbl_pay_money }}
              <ImportantChip></ImportantChip>
            </v-row>
            <v-row align="center" v-else dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_pay_money }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="7" md="7" lg="7">
            {{ dummy_payment_amount }}
            <span v-if="dummy_payment_amount.length > 0">円 </span>
          </v-col>
        </v-row>
        <!-- レジNo -->
        <!--
        <v-row dense class="mb-3">
          <v-col cols="12" sm="5" md="5" lg="5" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_cash_register_no }}
            </v-row>
          </v-col>
          <v-col cols="12" sm="7" md="7" lg="7">{{
            transPickupRequestCreateInput.register_no
          }}</v-col>
        </v-row>
-->
        <!-- レシートNo -->
        <!--
        <v-row dense class="mb-3">
          <v-col cols="12" sm="5" md="5" lg="5" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_receipt_no }}</v-row
            >
          </v-col>
          <v-col cols="12" sm="7" md="7" lg="7">
            {{ transPickupRequestCreateInput.receipt_no }}
          </v-col>
        </v-row>
-->
        <!-- 個口数 -->
        <v-row dense class="mb-3">
          <v-col cols="12" sm="5" md="5" lg="5" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-3 justify-sm-end">
              {{ wordList.lbl_unit_number }}
              <ImportantChip></ImportantChip>
            </v-row>
          </v-col>
          <v-col
            v-if="transPickupRequestCreateInput.unit > 0"
            cols="12"
            sm="7"
            md="7"
            lg="7"
          >
            {{ transPickupRequestCreateInput.unit }}個
          </v-col>
        </v-row>
        <!-- 備考 -->
        <v-row dense class="mb-3">
          <v-col cols="4" sm="5" md="5" lg="5" class="font-weight-black">
            <v-row align="center" dense class="form-label-row mr-15 justify-sm-end">
              {{ wordList.lbl_memo }}
            </v-row>
          </v-col>
          <v-col cols="8" sm="7" md="7" lg="7">
            {{ transPickupRequestCreateInput.delivery_notes }}
          </v-col>
          <v-col offset="4" cols="8" class="text-body-1 text-caption">
            {{ messageDeliveryNotes }}
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="justify-center flex-wrap">
        <!-- 戻るボタン -->
        <v-btn
          variant="flat"
          color="return"
          class="btn_width_1 my-2 mx-2"
          @click="onClickConfirmCancel"
        >
          <v-icon>mdi-arrow-left</v-icon>
          {{ wordList.btn_return }}
        </v-btn>
        <!-- 登録ボタン -->
        <v-btn
          variant="flat"
          color="primary"
          class="btn_width_1 my-2 mx-2"
          @click="onClickConfirmEntry"
        >
          <v-icon>mdi-playlist-edit</v-icon>
          {{ wordList.btn_regist_complete }}
        </v-btn>
      </v-card-actions>
      <v-overlay
        :model-value="overlay"
        class="d-flex align-center justify-center"
      >
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>
    </v-card>
    <!-- } 配達依頼登録確認ダイアログ -->
    <!-- 配達依頼登録完了ダイアログ { -->
    <v-card v-if="displayCompletedDialog" flat>
      <v-card
        v-if="
          createTransPickupRequestMutation !== null &&
          createTransPickupRequestMutation !== undefined
        "
        flat
      >
        <v-card-title class="mb-3 text-h5 font-weight-bold">
          {{ wordList.lbl_delivery_move_regist_complete }}
        </v-card-title>
        <v-card-text style="height: 500px" class="pt-5 confirm-display-text">
          <!-- 受付可能終了時間超過メッセージ -->
          <v-row v-if="overDeliveryEndTime">
            <v-col cols="10"> </v-col>
            <v-col cols="10" class="text-h5 text-red">
              {{ wordList.lbl_delivery_time_chk }}
            </v-col>
          </v-row>
          <!-- 受付番号 -->
          <v-row dense class="mb-3">
            <v-col cols="12" sm="5" md="5" lg="5" class="font-weight-black">
              <v-row align="center" dense class="form-label-row text-h5 mr-15 justify-sm-end">
                {{ wordList.lbl_reception_number }}
              </v-row>
            </v-col>
            <v-col cols="12" sm="7" md="7" lg="7" class="text-h5 d-flex align-center">
              {{
                createTransPickupRequestMutation.createTransPickupRequest
                  .reception_no
              }}
            </v-col>
          </v-row>
          <!-- 配達元 -->
          <v-row dense class="mb-3">
            <v-col cols="12" sm="5" md="5" lg="5" class="font-weight-black">
              <v-row align="center" dense class="form-label-row text-h5 mr-15 justify-sm-end">
                {{ wordList.lbl_delivery_source }}
              </v-row>
            </v-col>
            <v-col cols="12" sm="7" md="7" lg="7" class="text-h5 d-flex align-center">
              {{ shopSelectValues_from.name }}
            </v-col>
          </v-row>
          <!-- 配達先 -->
          <v-row dense class="mb-3">
            <v-col cols="12" sm="5" md="5" lg="5" class="font-weight-black">
              <v-row align="center" dense class="form-label-row text-h5 mr-15 justify-sm-end">
                {{ wordList.lbl_delivery_destination }}
              </v-row>
            </v-col>
            <v-col cols="12" sm="7" md="7" lg="7" class="text-h5 d-flex align-center">
              {{ shopSelectValues_to.name }}
            </v-col>
          </v-row>
          <!-- エリア -->
          <v-row dense class="mb-3">
            <v-col cols="12" sm="5" md="5" lg="5" class="font-weight-black">
              <v-row align="center" dense class="form-label-row text-h5 mr-15 justify-sm-end">
                {{ wordList.lbl_area }}
              </v-row>
            </v-col>
            <v-col cols="12" sm="7" md="7" lg="7" class="text-h5 d-flex align-center">
              {{ deliveryAreaName }}
            </v-col>
          </v-row>
          <!-- 配達希望時間 -->
          <v-row dense class="mb-3">
            <v-col cols="12" sm="5" md="5" lg="5" class="font-weight-black">
              <v-row align="center" dense class="form-label-row text-h5 mr-15 justify-sm-end">
                {{ wordList.lbl_delivery_time_select }}
              </v-row>
            </v-col>
            <v-col cols="12" sm="7" md="7" lg="7" class="text-h5 d-flex align-center">
              {{ display_delivery_time }}
            </v-col>
          </v-row>
          <!-- 個口数 -->
          <v-row dense class="mb-3">
            <v-col cols="12" sm="5" md="5" lg="5" class="font-weight-black">
              <v-row align="center" dense class="form-label-row text-h5 mr-15 justify-sm-end">
                {{ wordList.lbl_unit_number }}
              </v-row>
            </v-col>
            <v-col cols="12" sm="7" md="7" lg="7" class="text-h5 d-flex align-center">
              {{ transPickupRequestCreateInput.unit }}個
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="justify-center flex-wrap">
          <!-- 完了ボタン -->
          <v-btn
            variant="flat"
            color="return"
            class="btn_width_1 my-2 mx-2"
            @click="onClickCompletedGoStart"
          >
            <v-icon>mdi-arrow-left</v-icon>
            {{ wordList.btn_regist_comp }}
          </v-btn>
          <!-- 印刷ボタン -->
          <!--          
          <v-btn
            @click="onClickCompletedPrint"
            depressed
            color="primary"
            class="btn_width_1 my-2 mx-2"
            >{{ wordList.btn_print_tag }}</v-btn
          >
-->
        </v-card-actions>
      </v-card>
    </v-card>
    <!-- } オペレータ登録完了ダイアログ -->
    <AlertDialog
      v-model="errdialog"
      :title="wordList.lbl_err_dialog_title"
      :message="errMessage"
      type="error"
    />
  </v-container>
</template>

<script setup lang="ts">
import { reactive, onMounted, ref } from 'vue';
import { Form, Field, defineRule, configure } from 'vee-validate';
import { localize, setLocale } from '@vee-validate/i18n';
import { required, max, numeric, regex } from '@vee-validate/rules';
import ja from '@vee-validate/i18n/dist/locale/ja.json';
import ImportantChip from '@/components/ImportantChip.vue';
import AlertDialog from "@/components/AlertDialog.vue";
import type { TransPickupRequestCreateInput } from '@/generated/graphql';

import { useDeliveryMoveRegisterUiState } from './composables/useDeliveryMoveRegisterUiState';
import { useDeliveryMoveRegisterInit } from './composables/useDeliveryMoveRegisterInit';
import { useDeliveryMoveRegisterAddress } from './composables/useDeliveryMoveRegisterAddress';
import { useDeliveryMoveRegisterDeliveryTime } from './composables/useDeliveryMoveRegisterDeliveryTime';
import { useDeliveryMoveRegisterForm } from './composables/useDeliveryMoveRegisterForm';
import { useDeliveryMoveRegisterActions } from './composables/useDeliveryMoveRegisterActions';

defineRule('required', required);
defineRule('max', max);
defineRule('numeric', numeric);
defineRule('regex', regex);
configure({
  generateMessage: localize({ ja })
});
setLocale('ja');

// フォーム参照
const formRef = ref<InstanceType<typeof Form> | null>(null);

// 配達依頼作成 input
const transPickupRequestCreateInput = reactive<TransPickupRequestCreateInput>({
  area_code: '',
  chain_code: '',
  customer_code: '',
  delivery_id: 1,
  delivery_notes: '',
  delivery_shop_code: '',
  delivery_type: 1,
  payment_amount: null,
  payment_method: null,
  receipt_no: null,
  register_no: null,
  required_delivery_date: '',
  ship_from_shop_code: '',
  unit: 1,
  irregular_delivery_start_time: '',
  irregular_delivery_end_time: '',
  double_deli_oricon_flg: 0,
  charter_deli_oricon_flg: 0
});

// UI状態
const {
  errdialog,
  errMessage,
  overlay,
  displayConfirmDialog,
  displayCompletedDialog,
} = useDeliveryMoveRegisterUiState();

// 文言データ（各composableで共有するため先に定義）
const wordList = ref<Record<string, string>>({});

// 配達時間帯
const {
  listDeliveryArea,
  deliveryAreaName,
  acceptableEndTime,
  deliveryStartHourItem,
  deliveryStartHourValues,
  deliveryStartMinitItem,
  deliveryStartMinitValues,
  irregularDeliveryStartTime,
  irregularDeliveryEndTime,
  deliveryId_0_Flg,
  deliveryStartTime,
  overDeliveryEndTime,
  doubleDeliOriconCount,
  isDoubleDeli,
  charterDeliOriconCount,
  isCharterDeli,
  deliveryAvailabilityHeader,
  deliveryAvailabilityData,
  disp_deliveryAvailabilityData,
  display_delivery_time,
  deliverySelectDayBox,
  deliverySelectBox,
  doubleDeliCheckLabel,
  charterDeliChkLabel,
  onClickListDeliveryArea,
  getAreaList,
  onDeliveryAvailabilityClick,
  onChangeDeliveryStartHour,
  onChangeDeliveryStartMinit,
  formatDate,
} = useDeliveryMoveRegisterDeliveryTime({
  errdialog,
  errMessage,
  transPickupRequestCreateInput,
  wordList,
});

// 店舗選択・住所
const {
  shopToListItems,
  shopSelectValues_from,
  shopSelectValues_to,
  shopData_from_address,
  shopData_from_address1,
  shopData_to_address,
  shopData_to_address1,
  onUpdateShopFrom,
  onUpdateShopTo,
  onClickShopChangeBtn,
} = useDeliveryMoveRegisterAddress({
  errdialog,
  errMessage,
  transPickupRequestCreateInput,
  shopFromListItems: { value: [] } as any,
  deliveryAreaName,
  display_delivery_time,
  deliveryAvailabilityHeader,
  deliveryAvailabilityData,
  disp_deliveryAvailabilityData,
  deliveryId_0_Flg,
  deliveryStartHourItem,
  deliveryStartHourValues,
  deliveryStartMinitValues,
  listDeliveryArea,
  doubleDeliOriconCount,
  charterDeliOriconCount,
  getAreaList,
});

// 初期化
const {
  isWordListReady,
  paymentMethodItems,
  paymentRequiredFlg,
  unitItems,
  shopFromListItems,
  initialize,
  initOnMounted,
} = useDeliveryMoveRegisterInit({
  errdialog,
  errMessage,
  transPickupRequestCreateInput,
  shopSelectValues_from,
  shopSelectValues_to,
  shopData_from_address,
  shopData_from_address1,
  shopData_to_address,
  shopData_to_address1,
  deliveryAreaName,
  display_delivery_time,
  dummy_payment_amount: { value: '' } as any,
  wordList,
});

// フォーム
const {
  deliveryKbnRadioItems,
  deliveryKbnSelectValues,
  dummy_payment_amount,
  isFormValid,
  onClickDeliveryKbn,
  onChangePaymentMethod,
  commmaMoney,
  removeComma,
  onFocus,
  onBlur,
} = useDeliveryMoveRegisterForm({
  errdialog,
  errMessage,
  transPickupRequestCreateInput,
  shopSelectValues_from,
  shopSelectValues_to,
  shopData_from_address,
  shopData_from_address1,
  shopData_to_address,
  shopData_to_address1,
  shopToListItems,
  deliveryAreaName,
  display_delivery_time,
  deliveryAvailabilityHeader,
  deliveryAvailabilityData,
  disp_deliveryAvailabilityData,
  deliveryId_0_Flg,
  deliveryStartHourItem,
  deliveryStartHourValues,
  deliveryStartMinitValues,
  listDeliveryArea,
  paymentRequiredFlg,
});

// アクション
const {
  createTransPickupRequestMutation,
  messageDeliveryNotes,
  onClickOpenConfirmDialog,
  onClickConfirmCancel,
  onClickConfirmEntry,
  onClickCompletedGoStart,
} = useDeliveryMoveRegisterActions({
  errdialog,
  errMessage,
  overlay,
  displayConfirmDialog,
  displayCompletedDialog,
  transPickupRequestCreateInput,
  shopSelectValues_from,
  shopSelectValues_to,
  shopData_from_address,
  shopData_to_address,
  deliveryAreaName,
  display_delivery_time,
  deliveryKbnSelectValues,
  dummy_payment_amount,
  deliveryId_0_Flg,
  irregularDeliveryStartTime,
  irregularDeliveryEndTime,
  isDoubleDeli,
  isCharterDeli,
  doubleDeliOriconCount,
  charterDeliOriconCount,
  paymentRequiredFlg,
  overDeliveryEndTime,
  acceptableEndTime,
  initialize,
  removeComma,
  commmaMoney,
  onClickDeliveryKbn,
});

onMounted(async () => {
  await initOnMounted();
});
</script>

<style scoped>
/* disabled状態のテキストフィールドを黒字で表示 */
.disabled-text-field :deep(.v-field__input) {
  color: rgba(0, 0, 0, 0.87) !important;
  opacity: 1 !important;
}
.disabled-text-field :deep(.v-field--disabled) {
  opacity: 1 !important;
}
/* 配達希望時間選択の行折り返し防止 */
.delivery-time-row {
  flex-wrap: nowrap;
}
.delivery-time-select {
  min-width: 100px;
  width: 100px;
  flex: 0 0 100px;
}
.delivery-time-select :deep(.v-input__details) {
  display: none;
}
</style>
